import { Button } from '@shared/components/ui/button';
import { faFileArrowDown } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Loader2 } from 'lucide-react';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useExportPayoutItems } from '../../hooks';
import { PayoutItemsFilters } from '../../models';

interface ExportButtonProps {
  filters: Partial<PayoutItemsFilters>;
  columns?: string[];
}

export const ExportButton: FC<ExportButtonProps> = ({ filters, columns }) => {
  const { t } = useTranslation('codPayoutItems');
  const { exportPayoutItems, isExporting } = useExportPayoutItems();

  const handleExport = () => {
    exportPayoutItems(filters, columns);
  };

  return (
    <Button
      onClick={handleExport}
      disabled={isExporting}
      type="button"
      size="sm"
      variant="outline"
      className={`!py-[9px] !px-2 text-icon bg-body-bg transition-opacity duration-200 ${
        isExporting ? 'opacity-60 pointer-events-none' : ''
      }`}
      data-testid="export-excel-button"
      title={t('export.button', 'Exportar a Excel')}
    >
      {isExporting ? <Loader2 className="h-4 w-4 animate-spin" /> : <FontAwesomeIcon icon={faFileArrowDown} />}
    </Button>
  );
};
